// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"ClientsPlayers_pageHeader__LwkvY ClientsList_pageHeader__4a08u"};